<div class="container-fluid mt-3">
    <h3 translate>massCreate.title</h3>

    <!-- Section 1: Reservation Data -->
    <div class="card mb-3">
        <div class="card-header">
            <h5 class="mb-0" translate>massCreate.reservationData</h5>
        </div>
        <div class="card-body">
            <form [formGroup]="reservationForm">
                <div class="container-fluid row">
                    <div class="col-lg-4 col-md-6">
                        <label style="margin-top: 12px;" translate>technicalInspection.phoneNumber</label>
                        <input style="width: 200pt" type="text" class="form-control" formControlName="phoneNumber"
                            placeholder="{{'placeholder.enter' | translate}}"
                            [ngClass]="{ 'is-invalid': submittedForm && mainForm.phoneNumber.errors }">
                        <div class="invalid-feedback" *ngIf="mainForm.phoneNumber.errors?.required && submittedForm" translate>errors.required</div>
                        <div class="invalid-feedback" *ngIf="(mainForm.phoneNumber.errors?.minlength || mainForm.phoneNumber.errors?.maxlength) && submittedForm" translate>errors.invalidPhoneNumber</div>
                    </div>

                    <div class="col-lg-4 col-md-6">
                        <label style="margin-top: 12px;" translate>technicalInspection.email</label>
                        <input style="width: 200pt" type="text" class="form-control" formControlName="email"
                            placeholder="{{'placeholder.enter' | translate}}"
                            [ngClass]="{ 'is-invalid': submittedForm && mainForm.email.errors }">
                        <div class="invalid-feedback" *ngIf="mainForm.email.errors?.required && submittedForm" translate>errors.required</div>
                        <div class="invalid-feedback" *ngIf="mainForm.email.errors?.maxlength && submittedForm" translate>errors.inputTooLong</div>
                    </div>

                    <div class="col-lg-4 col-md-6">
                        <label style="margin-top: 12px;" translate>technicalInspection.reason</label>
                        <input style="width: 200pt" type="text" class="form-control" formControlName="name"
                            placeholder="{{'placeholder.enter' | translate}}"
                            [ngClass]="{ 'is-invalid': submittedForm && mainForm.name.errors }">
                        <div class="invalid-feedback" *ngIf="mainForm.name.errors?.required && submittedForm" translate>errors.required</div>
                        <div class="invalid-feedback" *ngIf="mainForm.name.errors?.maxlength && submittedForm" translate>errors.inputTooLong</div>
                    </div>

                    <div class="col-lg-4 col-md-6">
                        <label style="margin-top: 12px;" translate>technicalInspection.regNumber</label>
                        <input style="width: 200pt" type="text" class="form-control" formControlName="regNumber"
                            placeholder="{{'placeholder.enter' | translate}}"
                            [ngClass]="{ 'is-invalid': submittedForm && mainForm.regNumber.errors }">
                        <div class="invalid-feedback" *ngIf="mainForm.regNumber.errors?.required && submittedForm" translate>errors.required</div>
                        <div class="invalid-feedback" *ngIf="mainForm.regNumber.errors?.maxlength && submittedForm" translate>errors.inputTooLong</div>
                    </div>

                    <div class="col-lg-4 col-md-6">
                        <div style="width: 200pt">
                            <label style="margin-top: 12px;" translate>technicalInspection.category</label>
                            <select class="custom-select input-custom-size" formControlName="rvsCategory"
                                [compareWith]="compareById" (change)="onRvsCategoryChange()"
                                [ngClass]="{ 'is-invalid': submittedForm && mainForm.rvsCategory.errors }">
                                <option [ngValue]="null" disabled translate>placeholder.select</option>
                                <option *ngFor="let cat of rvsCategories" [ngValue]="cat">{{cat.description}}</option>
                            </select>
                            <div class="invalid-feedback" *ngIf="mainForm.rvsCategory.errors?.required && submittedForm" translate>errors.required</div>
                        </div>
                    </div>
                </div>
            </form>
        </div>
    </div>

    <!-- Section 2: Slot Selection (Collapsible) -->
    <div class="card mb-3">
        <div class="card-header" style="cursor: pointer" (click)="isCardOpen = !isCardOpen">
            <h5 class="mb-0">
                <button class="btn btn-link" type="button">
                    <i class="fa" [ngClass]="isCardOpen ? 'fa-chevron-up' : 'fa-chevron-down'"></i>
                    <span translate>massCreate.slotSelection</span>
                </button>
            </h5>
        </div>
        <div *ngIf="isCardOpen" class="card-body">
            <form [formGroup]="reservationForm">
                <div class="container-fluid row">
                    <!-- Date Picker -->
                    <div class="col-lg-4 col-md-6">
                        <label style="margin-top: 12px;" translate>technicalInspection.date</label>
                        <div style="width: 200pt" class="input-group mt-1">
                            <input class="form-control d-inline" [minDate]="minDate"
                                formControlName="searchDate" ngbDatepicker #d1="ngbDatepicker" readonly
                                (dateSelect)="onDateOrTechPointChange()">
                            <div class="input-group-append">
                                <button (click)="d1.toggle()" class="btn btn-outline-secondary fa fa-calendar" type="button"></button>
                            </div>
                        </div>
                    </div>

                    <!-- Tech Point Dropdown -->
                    <div class="col-lg-4 col-md-6">
                        <div style="width: 200pt">
                            <label style="margin-top: 12px;" translate>technicalInspection.techPointName</label>
                            <select class="custom-select input-custom-size" formControlName="searchTechPoint"
                                [compareWith]="compareById" (change)="onDateOrTechPointChange()">
                                <option [ngValue]="null" disabled translate>placeholder.select</option>
                                <option *ngFor="let tp of technicalPoints" [ngValue]="tp">{{tp.name}}</option>
                            </select>
                        </div>
                    </div>
                </div>

                <!-- Slots -->
                <div class="mt-4" *ngIf="isSlotsLoading">
                    <div class="d-flex justify-content-center">
                        <div class="spinner-border" role="status">
                            <span class="sr-only">Loading...</span>
                        </div>
                    </div>
                </div>

                <div class="mt-4" *ngIf="!isSlotsLoading && reservationForm.get('searchDate')?.value && reservationForm.get('searchTechPoint')?.value">
                    <div *ngIf="slotEntries.length === 0" class="alert alert-info" translate>
                        massCreate.noAvailableSlots
                    </div>

                    <div *ngIf="slotEntries.length > 0">
                        <div class="form-check mb-2">
                            <input class="form-check-input" type="checkbox" id="selectAll"
                                [(ngModel)]="selectAll" [ngModelOptions]="{standalone: true}"
                                (change)="toggleSelectAll()">
                            <label class="form-check-label font-weight-bold" for="selectAll" translate>
                                massCreate.selectAll
                            </label>
                            <span class="ml-2 text-muted">({{getSelectedCount()}} / {{slotEntries.length}})</span>
                        </div>
                        <hr>
                        <div class="row">
                            <div class="col-lg-3 col-md-4 col-sm-6" *ngFor="let entry of slotEntries; let i = index">
                                <div class="form-check mb-2">
                                    <input class="form-check-input" type="checkbox" [id]="'slot_' + i"
                                        [(ngModel)]="entry.selected" [ngModelOptions]="{standalone: true}"
                                        (change)="onSlotToggle()">
                                    <label class="form-check-label" [for]="'slot_' + i">
                                        {{entry.slot.time}}
                                    </label>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </form>
        </div>
    </div>

    <!-- Results -->
    <div *ngIf="results && !isCreating" class="alert" [ngClass]="results.failed > 0 ? 'alert-warning' : 'alert-success'">
        <span translate [translateParams]="{succeeded: results.succeeded, total: results.total}">massCreate.resultMessage</span>
        <span *ngIf="results.failed > 0"> | <span translate [translateParams]="{failed: results.failed}">massCreate.failedMessage</span></span>
    </div>

    <!-- Progress -->
    <div *ngIf="isCreating" class="mb-3">
        <div class="d-flex align-items-center">
            <div class="spinner-border spinner-border-sm mr-2" role="status"></div>
            <span translate [translateParams]="{succeeded: results!.succeeded, total: results!.total}">massCreate.progress</span>
        </div>
    </div>

    <!-- Create Button -->
    <div class="text-right" *ngIf="dataLoaded">
        <button class="btn btn-primary w-20" style="margin-top: 10px;"
            [disabled]="isCreating || getSelectedCount() === 0"
            (click)="createReservations()">
            <span *ngIf="isCreating" class="spinner-border spinner-border-sm mr-1"></span>
            <span translate>massCreate.createReservations</span>
        </button>
    </div>
</div>
